/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_MediaInputs */

const en_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Media`)
};

const es_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin medios`)
};

const fr_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun média`)
};

const de_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Medien`)
};

const ja_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアなし`)
};

const zh_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无媒体文件`)
};

const ar_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد وسائط`)
};

const id_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak Ada Media`)
};

const it_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun Media`)
};

const ru_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет медиа`)
};

const pt_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma Mídia`)
};

const ko_no_media = /** @type {(inputs: No_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미디어 없음`)
};

/**
* | output |
* | --- |
* | "No Media" |
*
* @param {No_MediaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_media = /** @type {((inputs?: No_MediaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_MediaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_media(inputs)
	if (locale === "es") return es_no_media(inputs)
	if (locale === "fr") return fr_no_media(inputs)
	if (locale === "de") return de_no_media(inputs)
	if (locale === "ja") return ja_no_media(inputs)
	if (locale === "zh") return zh_no_media(inputs)
	if (locale === "ar") return ar_no_media(inputs)
	if (locale === "id") return id_no_media(inputs)
	if (locale === "it") return it_no_media(inputs)
	if (locale === "ru") return ru_no_media(inputs)
	if (locale === "pt") return pt_no_media(inputs)
	return ko_no_media(inputs)
});